require('webpack-jquery-ui/selectmenu');
require('webpack-jquery-ui/datepicker');
require("../app/form.coffee")
require("../app/gratitude_block.coffee")
require("../app/feedback_admin.coffee")

window.pageInitFlag = false

pageInit = ->
  # formreset();
  new window.Form()
  new window.Gratitude()

  $('.base-radio-label').click ->
    if ($('.virtual-reception__method_email, #form_checkbox_SIMPLE_QUESTION_433_1').prop('checked'))
      $('.js-change-radio-text').css('display', 'inline');
    else
      $('.js-change-radio-text').css('display', 'none');

  $('.gosbar__visually-button').click ->
    changeSendTo()

  if (getCookie("specVersion") || "#specversion" == window.location.hash)
    changeSendTo()

changeSendTo = ->
  $.get '/controllers/virtual_reception_send_to.php', (data) ->
    $('.js-send-to-wrap').html('<select style="max-width: 100%;" name="form_dropdown_ADDRESSEE" id="form_dropdown_ADDRESSEE"><option value="Губернатору Кузбасса Сергею Цивилёву">Губернатору Кузбасса Сергею Цивилёву</option><option value="В Администрацию Правительства Кузбасса">В Администрацию Правительства Кузбасса</option>'+data+'</select>')
    $('.js-special-version-flag').html('<input type="hidden" name="special_version" value="Y">')
    $('.catcha_ajax').remove();
    return

getCookie = (e) ->
  o = document.cookie.match(new RegExp('(?:^|; )' + e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'))
  if o then decodeURIComponent(o[1]) else undefined

$(document).ready ->
  if window.pageInitFlag == false
    pageInit()
  window.pageInitFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/virtual_reception.coffee